import { useCallback, useMemo, useState } from 'react';
const ALL_STEPS = [
    'intro',
    'businessDetailsA',
    'businessDetailsB',
    'intent',
    'integrations',
    'qboXeroIntegration',
    'inviteTeam',
    'businessWebsite',
    'brand',
    'waiting',
    'closing'
];
const DATA_COLLECTION_STEPS = new Set([
    'businessDetailsA',
    'businessDetailsB',
    'intent',
    'inviteTeam',
    'businessWebsite',
    'brand',
    'integrations',
    'qboXeroIntegration'
]);
const SKIPPABLE_STEPS = new Set([
    'intent',
    'integrations',
    'businessWebsite',
    'brand'
]);
export const useOnboardingFlow = (options)=>{
    const [stepIndex, setStepIndex] = useState(0);
    const activeSteps = useMemo(()=>{
        return ALL_STEPS.filter((step)=>{
            if ((options === null || options === void 0 ? void 0 : options.skipInviteTeam) && step === 'inviteTeam') {
                return false;
            }
            if ((options === null || options === void 0 ? void 0 : options.skipQboXero) && step === 'qboXeroIntegration') {
                return false;
            }
            return true;
        });
    }, [
        options === null || options === void 0 ? void 0 : options.skipInviteTeam,
        options === null || options === void 0 ? void 0 : options.skipQboXero
    ]);
    const clampedIndex = Math.min(stepIndex, activeSteps.length - 1);
    const currentStep = activeSteps[clampedIndex];
    // Progress denominator: count every data-collection step regardless of which ones are
    // currently filtered out for navigation. inviteTeam (skipInviteTeam) and qboXeroIntegration
    // (skipQboXero) still occupy a slot on the bar so it does not jump or shrink mid-flow.
    const progressSteps = useMemo(()=>ALL_STEPS.filter((step)=>DATA_COLLECTION_STEPS.has(step)), []);
    const totalDataCollectionSteps = progressSteps.length;
    const dataCollectionIndex = progressSteps.indexOf(currentStep);
    const isDataCollectionStep = dataCollectionIndex >= 0;
    const isSkippableStep = SKIPPABLE_STEPS.has(currentStep);
    const prevStep = clampedIndex > 0 ? activeSteps[clampedIndex - 1] : null;
    const isBackDisabled = prevStep === 'businessDetailsB';
    const progress = isDataCollectionStep ? (dataCollectionIndex + 1) / totalDataCollectionSteps * 100 : 0;
    const goNext = useCallback(()=>{
        setStepIndex((prev)=>Math.min(prev + 1, activeSteps.length - 1));
    }, [
        activeSteps.length
    ]);
    const goBack = useCallback(()=>{
        setStepIndex((prev)=>Math.max(prev - 1, 0));
    }, []);
    return {
        currentStep,
        progress,
        isDataCollectionStep,
        isSkippableStep,
        isBackDisabled,
        goNext,
        goBack
    };
};
